import { useShallow } from "zustand/react/shallow";
import { SellarMap } from "../../../components/map/SellarMap";
import {
  defaultLondonLocation,
  MarkerEntityType,
} from "../../../components/map/SellarMap.shared";
import { useSellarMapStore } from "../../../components/map/SellarMapStore";
import { useSupplierRelationshipList } from "../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipList";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";

export const CustomerListMap = () => {
  const { business } = useSellarCurrentBusiness();

  const supplierRelationshipListMapQuery = useSupplierRelationshipList({
    limit: 100,
  });

  const mapConnections: MarkerEntityType[] = (
    supplierRelationshipListMapQuery.data?.pages.flatMap((page) => page) ?? []
  ).map((connection) => ({
    ...connection.Buyer,
    SupplierRetailerConnectionId: connection.id,
  }));

  const { add } = useSellarMapStore(
    useShallow((state) => ({
      add: state.add,
    })),
  );

  const businessLocation = business?.Location ?? null;
  add(businessLocation ?? defaultLondonLocation);

  return (
    <div className="mx-auto flex h-[80vh] w-full max-w-[1300px] justify-center">
      <SellarMap entities={mapConnections} displaying="buyer" />
    </div>
  );
};
